// import moment from 'moment'

function genaraterArr(len) {
  const arr = [];
  for (var i = 0; i < len; i++) arr.push(i);

  return arr;
}

const hours = genaraterArr(24);

const minutes = genaraterArr(60);

const seconds = genaraterArr(60);

export const disabledHours = () => hours;

export const disabledMinutes = () => minutes;

export const disabledSeconds = () => seconds;

// const defaultTimestamp = [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')]

export default {
  // disabledHours,
  // disabledMinutes,
  // disabledSeconds,
  // showTime: { defaultValue: defaultTimestamp }
};
